import { render } from "./AvaComponent.vue?vue&type=template&id=389f63d5&scoped=true"
import script from "./AvaComponent.vue?vue&type=script&lang=js"
export * from "./AvaComponent.vue?vue&type=script&lang=js"

import "./AvaComponent.vue?vue&type=style&index=0&id=389f63d5&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-389f63d5"]])

export default __exports__